export default __webpack_public_path__ + "static/media/answer.cdb5d424.svg";